module.exports = __webpack_public_path__ + "static/media/ic_selection.3562e597.svg";